export default __webpack_public_path__ + "static/media/symbol-defs.cfc5f6e9.svg";